// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1yArO","clinicsSelect":"TableHeading_clinicsSelect__BlHdv"};